import {NaturalReferencingMetricsWithPosition} from '../../../../../app/@types'
import {Headers, SortKeys, SortOrder} from '../types'
import React, {FC, useState} from 'react'
import {usePaginatedData, useSearchedData, useSortedData} from '../../../../../app/features'
import {KTSVG} from '../../../../helpers'
import CountUp from 'react-countup'
import {Pagination} from '../../../content/pagination/Pagination'
import {THead} from '../components/THead'
import {Modal} from '../../../modals/Modal'
import {KeywordNaturalReferencing} from '../../../modals/Keyword.natural-referencing'
import {Search} from '../../../content/forms'

type Props = {
    data: NaturalReferencingMetricsWithPosition[]
}

const headers: Headers<NaturalReferencingMetricsWithPosition>[] = [
    {key: 'keyword', label: 'Mots clés', className: 'fw-bolder text-muted bg-light min-w-30px'},
    {key: 'trend', label: 'Tendance', className: 'fw-bolder text-muted bg-light min-w-20px'},
    {key: 'position', label: 'Position', className: 'fw-bolder text-muted bg-light min-w-20px'},
    {key: 'sessions', label: 'Sessions', className: 'fw-bolder text-muted bg-light min-w-20px'},
]

const TREND_CATEGORIES = [
    {trend: 'no_change', french: 'NO_CHANGE', icon: 'arr097', color: 'orange'},
    {trend: 'up', french: 'UP', icon: 'arr062', color: 'success'},
    {trend: 'down', french: 'DOWN', icon: 'arr068', color: 'danger'},
]

const trendCategory = (trend: string) => {
    return TREND_CATEGORIES.find(category => category.trend === trend) ?? {
        trend: 'unknown',
        icon: '❓',
        color: 'secondary',
    }
}

const TablesWidget28: FC<Props> = ({data}) => {

    const [sortKey, setSortKey] = useState<SortKeys<NaturalReferencingMetricsWithPosition>>('keyword')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [activeModalId, setActiveModalId] = useState<string | null>(null);

    const dataSorted: NaturalReferencingMetricsWithPosition[] = useSortedData({
        data, sortKey, reverse: sortOrder === 'desc',
    })

    const {searchedData, setSearchQuery} = useSearchedData<NaturalReferencingMetricsWithPosition>({
        data: dataSorted,
    })

    const paginatedData = usePaginatedData<NaturalReferencingMetricsWithPosition>({
        currentPage, itemsPerPage, data: searchedData,
    })

    const handleClick = (index: string) => {
        setActiveModalId(index)
    }

    return (
        <>
            <div className="row mb-6">
                <div className="col-12">
                    <Search setSearchInput={setSearchQuery} showK={false} />
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                    />
                    <tbody>
                    {
                        paginatedData.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="text-hover-primary fw-bolder d-block mb-1 fs-7 cursor-pointer"
                                            data-bs-toggle="modal"
                                            data-bs-target={`#kt_modal_keyword_natural_referencing_${index}`}
                                            onClick={() => handleClick(index.toString())}
                                    >
                                        {item.keyword}
                                    </div>
                                    <KeywordNaturalReferencing id={`${index}`} title={item.keyword}
                                                               show={activeModalId === index.toString()}
                                                               setActiveModalId={setActiveModalId}
                                    />
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className={`badge badge-light-${trendCategory(item.trend).color} fs-9`}>
                                            <KTSVG
                                                path={`/media/icons/duotune/arrows/${trendCategory(item.trend).icon}.svg`}
                                                className={`svg-icon svg-icon-3 svg-icon-${trendCategory(item.trend).color}`} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-primary fs-9">
                                            <CountUp end={+item.position} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-info fs-9">
                                            <CountUp end={+item.sessions} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
            <Pagination itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        setCurrentPage={setCurrentPage}
                        setItemsPerPage={setItemsPerPage}
            />
        </>
    )
}

export {TablesWidget28}

const modalHandleClick = () => {

    return (
        <>
            <Modal
                button={{
                    bg: 'primary',
                    tooltip: 'Créer',
                    text: 'Créer',
                    icon: {show: true, svg: 'abstract/abs011'},
                }}
                modal={{
                    id: `add_to_contacts_${0}`,
                    size: 'lg',
                    content: <h1>Hello</h1>,
                }}
            />
        </>
    )
}